import React from 'react';

function toastStyles(type) {
  if (type === 'success') {
    return {
      background: '#F0FDF4',
      border: '1px solid #BBF7D0',
      color: '#15803D',
      icon: 'fa-circle-check',
    };
  }
  if (type === 'error') {
    return {
      background: '#FEF2F2',
      border: '1px solid #FECACA',
      color: '#B91C1C',
      icon: 'fa-circle-xmark',
    };
  }
  return {
    background: '#EFF6FF',
    border: '1px solid #BFDBFE',
    color: '#1D4ED8',
    icon: 'fa-circle-info',
  };
}

export default function ToastBanner({ toast }) {
  if (!toast?.msg) return null;

  const style = toastStyles(toast.type);

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 70,
        right: 20,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: style.background,
        border: style.border,
        color: style.color,
        padding: '12px 18px',
        borderRadius: 10,
        fontSize: 13,
        fontWeight: 600,
        boxShadow: '0 8px 24px rgba(0,0,0,.12)',
        maxWidth: 420,
      }}
    >
      <i className={`fas ${style.icon}`} style={{ fontSize: 16, flexShrink: 0 }} />
      <span>{toast.msg}</span>
    </div>
  );
}
